import { useDisclosure } from "@/hooks";
import {
	useAcceptRejectRoomRequest,
	useGetPendingRoomRequest,
} from "@/hooks/query-hooks/useRoom";
import { cn } from "@/libs/cn";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Drawer, Empty, Modal, Space } from "antd";
import { RoomDrawerTitle } from "./RoomDrawerTitle";
import { UserCard } from "./UserCard";

export function PendingRoomRequests(props: Room) {
	const { id } = props;

	const [open, { toggle }] = useDisclosure();

	const { data: pendingRequests = [], isLoading } = useGetPendingRoomRequest(
		id,
		!!id,
	);

	return (
		<>
			<Button
				onClick={toggle}
				className="text-primary-gradient border-f42! rounded-lg!"
				// icon={<EyeOutlined className="text-f42!" />}
				title="View Room Requests"
			>
				{pendingRequests?.length} Requests
			</Button>
			<Drawer
				title={<RoomDrawerTitle room={props} onClose={toggle} />}
				open={open}
				onClose={toggle}
				loading={isLoading}
				width={600}
				closeIcon={null}
			>
				{pendingRequests?.length > 0 ? (
					<Space
						direction="vertical"
						className="w-full!"
						size={"middle"}
					>
						{pendingRequests?.map((it, index) => (
							<PendingUserCard
								key={it.id}
								{...it}
								index={index + 1}
								roomId={id}
							/>
						))}
					</Space>
				) : (
					<Empty
						description="No pending requests found for this room!"
						classNames={{
							root: "mt-8",
							description: "font-poppins!",
						}}
					/>
				)}
			</Drawer>
		</>
	);
}

const PendingUserCard = (
	props: RoomRequestUser & { index: number; roomId: number },
) => {
	const { userId, userName, bookNo, index, roomId } = props;
	const [modal, contextHolder] = Modal.useModal();

	const { mutate, isPending } = useAcceptRejectRoomRequest();

	const handleConfirm = (action: "accept" | "reject") => {
		const isAccepted = action === "accept";

		modal.confirm({
			icon: isAccepted ? (
				<CheckOutlined className="text-success!" />
			) : (
				<CloseOutlined className="text-danger!" />
			),
			title: (
				<h3
					className={cn("font-poppins text-danger", {
						"text-success": isAccepted,
					})}
				>
					{isAccepted ? "Approve" : "Reject"} room request?
				</h3>
			),
			content: (
				<p className="font-poppins">
					Are you sure you want to {isAccepted ? "approve" : "reject"}{" "}
					{userName} (Book ID - {bookNo?.split("-")[1]})?
				</p>
			),
			onOk: () => mutate({ roomId, userId, action }),
			okText: isAccepted ? "Approve" : "Reject",
			okButtonProps: {
				className: "rounded-md!",
				danger: !isAccepted,
				style: {
					backgroundColor: isAccepted
						? "var(--color-success)"
						: "var(--color-danger)",
				},
				loading: isPending,
			},
			cancelButtonProps: {
				className: "rounded-md!",
				disabled: isPending,
			},
			closable: false,
		});
	};

	return (
		<>
			{contextHolder}
			<UserCard
				index={index}
				user={props}
				extra={
					<Space align="center">
						<Button
							shape="circle"
							icon={<CloseOutlined />}
							type="primary"
							danger
							title="Cancel"
							style={{
								backgroundColor: "#FEF2F2",
							}}
							className="aspect-square! text-danger!"
							onClick={() => handleConfirm("reject")}
						/>
						<Button
							shape="circle"
							icon={<CheckOutlined />}
							type="primary"
							title="Accept"
							style={{
								backgroundColor: "#D7F2E2",
							}}
							className="aspect-square! text-success!"
							onClick={() => handleConfirm("accept")}
						/>
					</Space>
				}
			/>
		</>
	);
};
